import React from 'react';
import PropTypes from 'prop-types';
import styles from '../index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class OriginalList extends React.PureComponent {
    static propTypes = {
        list: PropTypes.array,
    };

    render() {
        const { list } = this.props;

        return (
            <div className={styles.content}>
                <h1 className={styles.pageTitle}>凤凰网原创内容</h1>
                <div className={styles.list}>
                    <ul className="clearfix">
                        {list.map((item, index) => (
                            <li key={item.articleUrl} style={{ marginRight: (index + 1) % 4 === 0 ? '0px' : '12px' }}>
                                <article>
                                    <a href={item.articleUrl} target="_blank" rel={rel} className={styles.articleLink}>
                                        <p>
                                            <img src={item.thumbnails} className={styles.trans} alt="" />
                                        </p>
                                        <h2>{item.title}</h2>
                                    </a>
                                    <a href={item.columnUrl} target="_blank" rel={rel} className={styles.columnLink}>
                                        <span>{item.name}</span>
                                    </a>
                                </article>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(OriginalList);
